import { BaseApiService } from '../base/BaseApiService';
import { ApiResponse } from '../../types/api';

export interface FastchipClusterSettingsDto {
  er2Enabled: boolean;
  dhEnabled: boolean;
  defaultCluster: string;
  updatedAtUtc?: string;
}

class FastchipClusterSettingsService extends BaseApiService {
  async getSettings(): Promise<FastchipClusterSettingsDto> {
    const response = await this.api.get<ApiResponse<FastchipClusterSettingsDto>>(
      '/fastchip-cluster-settings'
    );
    return this.extractData(response);
  }

  async updateSettings(data: FastchipClusterSettingsDto): Promise<FastchipClusterSettingsDto> {
    const response = await this.api.put<ApiResponse<FastchipClusterSettingsDto>>(
      '/fastchip-cluster-settings',
      data
    );
    return this.extractData(response);
  }
}

export const fastchipClusterSettingsService = new FastchipClusterSettingsService();
